export default __webpack_public_path__ + "static/media/baby.366c69dd.jpg";